module.exports = __webpack_public_path__ + "static/media/powerplatformMobile.bf51a02d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/powerplatformMobile.jpg
// module id = 868
// module chunks = 13